// MetricsPagesCardMUI.jsx
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { TrendingUp, Package, Target } from "lucide-react/dist/cjs/lucide-react";
import PageCarousel from "./metricCarousel";
import { roundToGrossMargin } from "../utils/utils";


// assumes formatTooltipPriceM, roundToZeroDecimal, roundToOneDecimal are in scope

export default function MetricsPagesCardMUI({ metaSummary, isAdmin,roundToOneDecimal, roundToZeroDecimal, formatTooltipPriceM }) {
  const stockPage = (
    <div className="flex w-full justify-between items-center px-2">
        <div className="flex items-center justify-between">
            <div className="p-2 bg-chart-1/10 rounded-sm">
            <Package className="w-5 h-5" color="blue" />
            </div>
            <h6 className="font-semibold text-foreground p-2 mb-0">Stock Metrics</h6>
        </div>

        <div className="flex items-center justify-between gap-1">
            <span className="text-xs text-muted-foreground">Value: </span>
            <div className="text-right font-bold text-xs">
                {formatTooltipPriceM(metaSummary?.inv_value ?? 0)}
            
            </div>
        </div>

        <div className="flex items-center justify-between gap-1">
            <span className="text-xs text-muted-foreground">Count: </span>
            <div className="text-right font-bold text-xs">
                {metaSummary?.inventory?.toLocaleString?.() ?? "—"}
            
            </div>
        </div>

        <div className="flex items-center justify-between gap-1">
            <span className="text-xs text-muted-foreground">Avg Aging: </span>
            <div className="text-right font-bold text-xs">
                {roundToZeroDecimal(metaSummary?.inv_aging ?? 0)} days
           
            </div>
        </div>
    </div>
  );

  const salesPage = (
    <div className="flex w-full justify-between items-center  px-2">
    <div className="flex items-center justify-between">
        <div className="p-2 bg-chart-1/10 rounded-sm">
        <TrendingUp className="w-5 h-5" color="orange" />
        </div>
        <h6 className="font-semibold text-foreground p-2 mb-0">Sales Metrics</h6>
    </div>

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Value: </span>
        <div className="text-right font-bold text-xs">
            {formatTooltipPriceM(metaSummary?.sold_value ?? 0)}
        
        </div>
    </div>

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Count: </span>
        <div className="text-right font-bold text-xs">
            {metaSummary?.sales?.toLocaleString?.() ?? "—"}
        
        </div>
    </div>

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Avg Aging: </span>
        <div className="text-right font-bold text-xs">
            {roundToZeroDecimal(metaSummary?.sold_aging ?? 0)} days
        
        </div>
    </div>
    </div>
  );

  const healthPage = (
    <div className="flex w-full justify-between items-center  px-2">
    <div className="flex items-center justify-between">
        <div className="p-2 bg-chart-1/10 rounded-sm">
        <Target className="w-5 h-5" color="red" />
        </div>
        <h6 className="font-semibold text-foreground p-2 mb-0">Business Health</h6>
    </div>

    {isAdmin && (
    <>
        <div className="flex items-center justify-between gap-1">
            <span className="text-xs text-muted-foreground">GMROI: </span>
            <div className="text-right font-bold text-xs">
                    {metaSummary.gross_margin_roi !== null || Number.isFinite(metaSummary?.gross_margin_roi) ? roundToGrossMargin(metaSummary?.gross_margin_roi) : "-"} 
            </div>
        </div>

        <div className="flex items-center justify-between gap-1">
            <span className="text-xs text-muted-foreground">Gross Margin: </span>
            <div className="text-right font-bold text-xs">
                {metaSummary.gross_margin !== null || Number.isFinite(metaSummary?.gross_margin) ? roundToGrossMargin(metaSummary?.gross_margin) : "-"}
            </div>
        </div>
    </>
    )}

    

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Turn: </span>
        <div className="text-right font-bold text-xs">
            {roundToOneDecimal(metaSummary?.turn ?? 0)}x
        </div>
    </div>

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Overhang: </span>
        <div className="text-right font-bold text-xs">
            {roundToZeroDecimal(metaSummary?.overhang ?? 0)} days
        
        </div>
    </div>

    <div className="flex items-center justify-between gap-1">
        <span className="text-xs text-muted-foreground">Needs/Surplus: </span>
        <div className="text-right font-bold text-xs">
            {roundToZeroDecimal(metaSummary?.needs ?? 0)}
        </div>
    </div>
    </div>
  );

  return (
    <Card className=" w-full bg-white border relative shadow-none z-0">
      <CardContent className="pt-1 px-4 md:px-3 pb-1">
        <PageCarousel
          ariaLabel="Metrics Pages"
          slides={[stockPage, salesPage, healthPage]}
          intervalMs={4500}
          showDots={false}
          showArrows
        />
      </CardContent>
    </Card>
  );
}
